import React, { useContext, useEffect, useState } from 'react';
import './games-widget-container.scss';
import { ReactComponent as StarIcon } from '../../assets/star.svg';
import { ReactComponent as FavoriteIcon } from '../../assets/favourite.svg';
import { ReactComponent as PlayIcon } from '../../assets/play.svg';
import { useHistory } from 'react-router-dom';

import GamesContainer from '../../components/games-container/games-container';
import { StateContext } from '../../contexts/state';
import messenger from '../../services/messenger';
import Rate from '../../components/rate/rate';

const HeaderGame = ({ previewGame, fadeInOut, searchFunction }) => {
	const dataContext = useContext(StateContext);
	const [isFavorite, setIsFavorite] = useState(false);
	useEffect(() => {
		setIsFavorite(previewGame?.categories.includes('Favorites'));
	}, [previewGame]);

	const onStarClicked = () => {
		dataContext.setFavorite(previewGame.id, !isFavorite);
		setIsFavorite(!isFavorite);
		messenger.log({ eventAction: `Favorite ${isFavorite ? 'Remove' : 'Add'}`, eventLabel: previewGame.name });
	};
	const onPlayClicked = () => {
		document.location.href.includes('?game=')
			? (document.location.href = document.location.href.replace(/\?game=.*/, `?game=${previewGame.id}`))
			: window.open(`?game=${previewGame.id}`);
		messenger.log({ eventAction: 'Game Chosen', eventLabel: previewGame.name });
	};
	const doSearch = ev => {
		searchFunction(ev.target.value);
	};

	const logSearch = ev => {
		if (ev.target.value && ev.target.value.trim().length > 2) {
			messenger.log({ eventAction: 'Search', eventLabel: ev.target.value });
		}
	};
	return (
		<div className="games-widget-container__game-preview">
			<div className="games-widget-container__game-preview__search-and-desc">
				<input onChange={doSearch} onBlur={logSearch} className="search" placeholder="Search"></input>
				<div>
					<span
						style={{ animation: (fadeInOut ? 'fade-in' : 'fade-out') + ' 1s' }}
						className="games-widget-container__game-preview__search-and-desc__title"
					>
						{previewGame?.name}
					</span>
					<div
						style={{ animation: (fadeInOut ? 'fade-in' : 'fade-out') + ' 1s' }}
						className="games-widget-container__game-preview__search-and-desc__rate-and-category"
					>
						<span className="games-widget-container__game-preview__search-and-desc__rate-and-category__rate">
							{previewGame && Number((previewGame?.rating / 20).toFixed(1))}
							{previewGame && (
								<StarIcon className="games-widget-container__game-preview__search-and-desc__rate-and-category__rate__star" />
							)}
						</span>
						<span className="games-widget-container__game-preview__search-and-desc__rate-and-category__category">
							{previewGame?.categories.filter(c => c != 'Top Games').join(', ')}
						</span>
					</div>
				</div>

				<span
					style={{ animation: (fadeInOut ? 'fade-in' : 'fade-out') + ' 1s' }}
					className="games-widget-container__game-preview__search-and-desc__description"
				>
					{previewGame?.description}
				</span>
			</div>
			<div
				style={{ animation: (fadeInOut ? 'fade-in' : 'fade-out') + ' 1s' }}
				className="games-widget-container__game-preview__actions"
			>
				<PlayIcon
					onClick={onPlayClicked}
					className={` games-widget-container__game-preview__actions__action 
					games-widget-container__game-preview__actions__action--play
					`}
				/>
				<FavoriteIcon
					onClick={onStarClicked}
					className={`games-widget-container__game-preview__actions__action
					 games-widget-container__game-preview__actions__action--like
							${isFavorite ? 'games-widget-container__game-preview__actions__action--active' : ''}
					 `}
				/>
			</div>
			<div
				style={{ animation: (fadeInOut ? 'fade-in' : 'fade-out') + ' 1s' }}
				className="games-widget-container__game-preview__image"
			>
				<img src={previewGame?.images.screenshot_1} />
			</div>
		</div>
	);
};
let i = 0; //meh
const GamesWidgetContainer = () => {
	const history = useHistory();

	const dataContext = useContext(StateContext);
	const [previewGame, setPreviewGame] = useState();
	const [topGames, setTopGames] = useState([]);
	const [shuffle, setShuffle] = useState();
	const [restartShuffle, setRestartShuffle] = useState();
	const [fadeInOut, setFadeInOut] = useState(true);
	const [name, setName] = useState();
	const [searchGames, setSearchGames] = useState([]);

	const shuffleArray = array => {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			const temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	};

	const filterAndSetGames = (setGamesFn, name) => {
		let games = [],
			data = dataContext.data;
		games =
			data && name?.length > 0
				? data.data?.content.filter(game =>
						(game?.description.toLowerCase().includes(name.toLowerCase()) || game?.name.toLowerCase().includes(name.toLowerCase()))
				  )
				: data?.topGames || [];
		setGamesFn(games);
		return games;
	};

	useEffect(() => {
		if (name?.length > 0) filterAndSetGames(setSearchGames, name);
	}, [name]);

	useEffect(() => {
		let newTopGames = dataContext.data?.data?.content?.filter(game =>
			game.categories.indexOf('Top Games') === -1 ? false : true
		);
		if (newTopGames) {
			shuffleArray(newTopGames);
			setTopGames(newTopGames);
		}
	}, [dataContext.data.data.content]);
	useEffect(() => {
		if (topGames && topGames.length) {
			if (shuffle) {
				clearInterval(shuffle);
				setShuffle(undefined);
			}
			setShuffle(setInterval(() => shuffleTopGames(), 5000));
			shuffleTopGames();
		}
	}, [topGames]);

	const shuffleTopGames = () => {
		i = (i + 1) % topGames.length;

		if (topGames) {
			setFadeInOut(false);
			setTimeout(() => {
				setPreviewGame(topGames[i]);
				setFadeInOut(true);
			}, 800);
		}
	};

	useEffect(() => {
		return () => {
			setShuffle(undefined);
			// setTopGames(null);
			setSearchGames(null);
		};
	}, []);

	const onGameClick = game => {
		messenger.log({ eventAction: 'Game Selected', eventLabel: game.name });
		if (shuffle) {
			clearInterval(shuffle);
			setShuffle();
		}
		if (restartShuffle) {
			clearTimeout(restartShuffle);
			setRestartShuffle();
		}
		setPreviewGame(game);
		setRestartShuffle(
			setTimeout(() => {
				setShuffle(setInterval(() => shuffleTopGames(topGames), 5000));
			}, 10000)
		);
	};

	return (
		<div className="games-widget-container">
			<HeaderGame previewGame={previewGame} fadeInOut={fadeInOut} searchFunction={setName} />
			<GamesContainer onGameClick={onGameClick} games={name ? searchGames : dataContext.data?.data?.content} />
			<Rate />
		</div>
	);
};

export default GamesWidgetContainer;
